import React from 'react';

import { expVal } from '@confluence/feature-experiments';
import { LoadableLazy } from '@confluence/loadable';

const FloatingEnterpriseHerContentLoadable = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-FloatingEnterpriseHerContent" */
				'./FloatingEnterpriseHerContent.tsx'
			)
		).FloatingEnterpriseHerContent,
});

export const FloatingEnterpriseHerContainer = (): React.JSX.Element | null => {
	if (!expVal('enterprise_her', 'isEnabled', false)) {
		return null;
	}

	return <FloatingEnterpriseHerContentLoadable />;
};
